import {
  AccuracyDisplay,
  GammaAccuracy,
  GammaAccuracyDefinition,
} from "@/types/location/location-accuracy";

export const LOCATION_ACCURACY: Record<GammaAccuracy, GammaAccuracyDefinition> =
  {
    [GammaAccuracy.Point]: {
      name: "Point",
      description: "Point",
      accuracy: AccuracyDisplay.High,
    },
    [GammaAccuracy.Polygon]: {
      name: "Polygon",
      description: "Polygon",
      accuracy: AccuracyDisplay.High,
    },
    [GammaAccuracy.MultiPolygon]: {
      name: "MultiPolygon",
      description: "Multi Polygon",
      accuracy: AccuracyDisplay.High,
    },
    [GammaAccuracy.Organisation]: {
      name: "Organisation",
      description: "Organisation",
      accuracy: AccuracyDisplay.High,
    },
    [GammaAccuracy.SubAddressPoint]: {
      name: "SubAddressPoint",
      description: "Sub Address Point",
      accuracy: AccuracyDisplay.High,
    },
    [GammaAccuracy.AddressPoint]: {
      name: "AddressPoint",
      description: "Address Point",
      accuracy: AccuracyDisplay.High,
    },
    [GammaAccuracy.Building]: {
      name: "Building",
      description: "Building",
      accuracy: AccuracyDisplay.High,
    },
    [GammaAccuracy.BuildingGroup]: {
      name: "BuildingGroup",
      description: "Building Group",
      accuracy: AccuracyDisplay.Low,
    },
    [GammaAccuracy.Thoroughfare]: {
      name: "Thoroughfare",
      description: "Thoroughfare",
      accuracy: AccuracyDisplay.Low,
    },
    [GammaAccuracy.Postcode]: {
      name: "Postcode",
      description: "Postcode",
      accuracy: AccuracyDisplay.Low,
    },
    [GammaAccuracy.Locality]: {
      name: "Locality",
      description: "Locality",
      accuracy: AccuracyDisplay.Low,
    },
    [GammaAccuracy.PostTown]: {
      name: "PostTown",
      description: "Post Town",
      accuracy: AccuracyDisplay.Low,
    },
    [GammaAccuracy.County]: {
      name: "County",
      description: "County",
      accuracy: AccuracyDisplay.Low,
    },
    [GammaAccuracy.AddressNotMatched]: {
      name: "AddressNotMatched",
      description: "Address not matched",
      accuracy: AccuracyDisplay.Low,
    },
  } as const;
